import { Component, Input } from '@angular/core';


@Component({
    selector: 'collapse-section',
    templateUrl: './collapse-section.component.html',
    styleUrls: ['./collapse-section.component.scss'],
    imports: []
})
export class CollapseSectionComponent {
  @Input() expandLabel: string = 'Show More';
  @Input() collapseLabel: string = 'Show Less';
  @Input() expanded: boolean = true;

  toggle(): void {
    this.expanded = !this.expanded;
  }
}